module.exports = __webpack_public_path__ + "static/img/world_innovator_06.ec82cc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/world_innovator_06.jpg
// module id = 164
// module chunks = 1